module.exports = __webpack_public_path__ + "img/JOC_3175.1290f6d4.webp";